export default {"src":"/_next/static/media/map-pin.c7c0e985.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};